<template>
  <div>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <b-col cols="12" class="mb-1">
          <div class="d-flex align-items-center justify-content-end">
            <b-button @click="exportExcel(
                pcc,
                ['Product Name', 'Category', 'Total Request', 'Periode'],
                ['name', 'category', 'total', 'period'],
                ['Request PCC'],
                formatJson
              )" variant="primary"
              >Export Excel</b-button
            >
          </div>
        </b-col>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-start mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="mr-1 per-page-selector d-inline-block ml-50"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
        >
          <label class="mr-1">
            Search
          </label>
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              class="d-inline-block"
              placeholder="Search..."
              v-model="searchWord"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Larger screen than mobile -->
    <div class="d-none d-md-flex">
      <b-table
        class="w-100 border"
        responsive
        striped
        :items="pcc"
        :fields="pccFields"
      >
        <template #cell(total)="pcc">
          <div class="d-flex justify-content-between">
            <b-button variant="link" style="text-align:left" @click="showRatingDetail(pcc.item.product_kode,pcc.item.period)">
              {{ pcc.item.total }}
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- Mobile screen -->
    <div class="d-flex d-md-none flex-column">
      <!-- Loading -->
      <div v-if="isBusy" class="text-center text-danger my-2">
        <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
        <strong class="text-secondary">Loading...</strong>
      </div>
      <!-- Data -->
      <div v-if="!isBusy && pcc.length == 0" class="text-center text-danger my-2">
        <strong class="text-secondary">No data</strong>
      </div>
      <b-row
        v-if="!isBusy && pcc.length > 0"
        v-for="(item, index) in pcc"
        :key="item.id"
        class="mb-3 list-item"
      >
        <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
          <strong class="flex-grow-1 truncate">{{ item.product.PRODUCT }}</strong>
        </b-col>
        <b-col cols="12" class="d-flex flex-wrap">
          <div style="font-size: 0.75rem;">
            <p><strong>CATEGORY: </strong>{{ item.product.category ? item.product.category.name : '-' }}</p>
            <p>
              <strong>TOTAL REQUEST: </strong>
              <strong class="flex-grow-1 truncate">
                <a style="color: #19497E; text-align: left" @click="showRatingDetail(item.product_kode,item.period)">
                  {{ Number(item.total).toFixed(0) }}
                </a>
              </strong>
            </p>
            <p><strong>PERIOD: </strong>{{ item.period }}</p>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            Showing {{ pagination.from }} to {{ pagination.to }} of
            {{ pagination.total }} entries
          </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            @input="changePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal hide-footer title="Participants" size="xl" id="rating-modal">
      <rating-detail-pcc-table :pccId="selectedPCC" :period="selectedPeriod" />
    </b-modal>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import VSelect from 'vue-select'
import {
  BSpinner,
  BRow,
  BCol,
  BTable,
  BFormCheckbox,
  BButton,
  BFormInput,
  BPagination,
  BModal,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import RatingDetailPccTable from '@/views/admin/pcc/RatingDetailPCCTable'

export default {
  components: {
    BSpinner,
    BTable,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
    VSelect,
    BFormInput,
    BPagination,
    BModal,
    RatingDetailPccTable,
  },

  directives: {
    Ripple,
    VBModal,
  },

  data() {
    return {
      sortBy: 'start_datetime',
      sortDesc: true,
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      pcc: [],
      pccFields: [
        {
          key: 'product.PRODUCT',
          label: 'Product Name',
          sortable: true,
        },
        {
          key: 'product.category',
          formatter: (val, key, item) => {
            return val ? val.name : ''
          },
          label: 'Category',
          sortable: true,
        },
        {
          key: 'total',
          formatter: (val, key, item) => {
            return Number(val).toFixed(0)
          },
          label: 'Total Request',
          sortable: true,
        },
        'period'
      ],
      selectedPCC: '',
      selectedPeriod: '',
      searchWord: '',
    }
  },

  watch: {
    perPage() {
      this.fetchPcc()
    },
    currentPage() {
      this.fetchPcc()
    },
    searchWord(newVal) {
      this.searchByTitle()
    },
  },

  mounted() {
    this.fetchPcc()
  },

  methods: {
    fetchPcc() {
      this.isBusy = true

      this.$http
        .get('/pcc/request', {
          params: {
            page: this.currentPage,
            perPage: this.perPage,
            s: this.searchWord.toString().trim(),
            // sort: `${this.sortDesc ? '-' : ''}${this.sortBy}`,
          },
        })
        .then(({ data }) => {
          this.currentPage = data.current_page
          this.pagination.total = data.total
          this.pagination.from = data.from
          this.pagination.to = data.to
          this.pcc = data.data
        })
        .finally(() => {
          this.isBusy = false
        })
    },

    searchByTitle: debounce(function() {
      this.fetchPcc()
    }, 200),

    changePage(page) {
      this.currentPage = page
    },

    sortingChanged({ sortBy, sortDesc }) {
      ;(this.sortBy = sortBy), (this.sortDesc = sortDesc)
      this.fetchPcc()
    },

    exportExcel (records, headers, fieldVal, filename, formatJson) {
      import('@/libs/Export2Excel').then(excel => {
          const list = records
          const data = formatJson(fieldVal, list)
          excel.export_json_to_excel({
            header: headers,
            data,
            filename,
            autoWidth: true,
            bookType: 'xlsx'
          })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        let data = null
        data = v[j]

        if (j === 'name') {
          data = v.product.PRODUCT
        }

        if (j === 'category') {
          data = v.product.category ? v.product.category.name : ''
        }
        
        if (j === 'total') {
          data = v.total
        }

        return data
      }))
    },
    showRatingDetail(pccId,period) {
      this.selectedPCC = pccId
      this.selectedPeriod = period
      this.$bvModal.show('rating-modal')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
